module.exports = __webpack_public_path__ + "img/undraw_Forms_re_pkrt.b9885ca4.svg";